export enum BookingOrderByOption {
	NAME = 'NAME',
	EMAIL = 'EMAIL',
	BOOKING_ID = 'BOOKING_ID',
	TRIP_DATE = 'TRIP_DATE',
	CREATED_DATE = 'CREATED_DATE',
	AMOUNT = 'AMOUNT',
	STATUS = 'STATUS',
}
